import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { followUpApi } from 'services/results/follow-up'
import { canViewFollowUpComparison } from 'services/results/follow-up-access'
import { useNotification } from 'lib/context/notification.context'
import { StrokedButton } from 'views/components/UI/Buttons'
import SkillsComparisonContent from './SkillsComparisonContent'
import BetesaComparisonContent from './BetesaComparisonContent'

export default function SkillsComparisonDialog({
  processId,
  originalId,
  followUpId,
  userId,
  userName,
  onClose,
  category = 'skills',
}: {
  processId: number
  originalId: number
  followUpId: number
  userId: number
  userName: string
  onClose: () => void
  category?: 'skills' | 'betesa'
}) {
  const role = useSelector((state: any) => state.auth.role)
  const allowed = canViewFollowUpComparison(role)
  const [comparison, setComparison] = useState<any>(null)
  const [error, setError] = useState(false)
  const [busy, setBusy] = useState(false)
  const { getError } = useNotification()
  useEffect(() => {
    let active = true
    setComparison(null)
    setError(false)
    if (allowed) {
      followUpApi(processId, `${category === 'betesa' ? 'betesa/' : ''}comparison/${followUpId}`)
        .then((data) => {
          if (!active) return
          if (
            Number(data.initial.id) !== originalId ||
            Number(data.follow_up.id) !== followUpId ||
            Number(data.follow_up.user_id) !== Number(userId) ||
            Number(data.follow_up.process_id) !== processId
          ) {
            throw new Error('La comparación no corresponde a la selección')
          }
          setComparison(data)
        })
        .catch(() => {
          if (active) setError(true)
        })
    }
    return () => {
      active = false
    }
  }, [allowed, processId, originalId, followUpId, userId, category])
  const action = async (work: () => Promise<unknown>) => {
    if (!allowed) return
    setBusy(true)
    try {
      await work()
    } catch {
      getError('No se pudo descargar el comparativo. Comprueba tus permisos y vuelve a intentarlo.')
    } finally {
      setBusy(false)
    }
  }
  if (!allowed) return null
  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="lg" aria-labelledby="skills-comparison-title">
      <DialogTitle id="skills-comparison-title">
        Comparativo {category === 'betesa' ? 'Betesa' : '3D Skills'} · {userName}
      </DialogTitle>
      <DialogContent dividers>
        <p>Consulta exclusiva de administración.</p>
        {error ? (
          <p role="alert">
            No se pudo cargar el comparativo. Comprueba tus permisos y que ambas mediciones estén completadas.
          </p>
        ) : comparison ? (
          category === 'betesa' ? (
            <BetesaComparisonContent comparison={comparison} processId={processId} busy={busy} action={action} />
          ) : (
            <SkillsComparisonContent comparison={comparison} processId={processId} busy={busy} action={action} />
          )
        ) : (
          <p role="status">Cargando comparativo…</p>
        )}
      </DialogContent>
      <DialogActions>
        <StrokedButton onClick={onClose}>Cerrar comparativo</StrokedButton>
      </DialogActions>
    </Dialog>
  )
}
